import { Component, EventEmitter, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUserStatus } from '../../../models/user';

@Component({
  selector: 'andor-user-status-btn',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-status-btn.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './user-status-btn.scss',
})
export class UserStatusBtn {
  status = input('online');
  isOnline = input<SharedUserStatus>('online');
  @Output() toggle = new EventEmitter();
}
